import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../../Popup';

import styles from './style.module.scss';

const OOPReminderPopup = ({ onClose, cancelAction }) => {
    return (
        <Popup
            className={`popup-sm`}
            onCloseClick={cancelAction}
            config={{
                fullScreen: false,
                scrollable: true,
                noPadding: false,
                topGradient: false,
                style: {
                    height: '400px',
                    width: '600px',
                },
            }}
        >
            <div className={styles.oopReminderContainer}>
                <h5 className={styles.popupHeader}>Order Of Play Reminder</h5>
                <p className="text-medium text-center">
                    {`If there is a match following the walkover, you MUST first add a "not before" start time to the next scheduled on the court prior to saving the withdrawal.`}
                </p>
                <p className="text-medium text-center">
                    DO NOT SAVE THE WITHDRAWAL UNTIL COMPLETED.
                </p>
                <button
                    className="btn text-uppercase btn-block btn-primary"
                    type="button"
                    onClick={onClose}
                >
                    Got It
                </button>
            </div>
        </Popup>
    );
};

OOPReminderPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    cancelAction: PropTypes.func.isRequired,
};

export default OOPReminderPopup;
